import React from 'react'
import styled from 'styled-components'
import { PaymentReturnProps } from './paymentReturn.props'
import { useBoricaResponse } from '@sentecacommerce-theme/lib';

export const PaymentReturn = ({ labels }: PaymentReturnProps) => {
  const boricaResponse = useBoricaResponse();

  return (
    <Container>
      <img
        src="https://production.hippoland-contents.com/platform/media/borica-6042343b61317e001288942c-5fec77c8c7bfa70018ddf7a8.jpg"
        width="200"
        alt="Борика"
      />
      <p className="m-3" style={{ color: 'red' }}>
        {labels?.paymentFailed} #{boricaResponse.RC || 'N/A'}
      </p>
    </Container>
  )
}

const Container = styled.div.attrs({
  className: 'd-flex align-items-center flex-column justify-content-center',
})`
  min-height: 25rem;
`
